import { render, staticRenderFns } from "./TenantStatistic.vue?vue&type=template&id=e727b21a&scoped=true&"
import script from "./TenantStatistic.vue?vue&type=script&lang=ts&"
export * from "./TenantStatistic.vue?vue&type=script&lang=ts&"
import style0 from "./TenantStatistic.vue?vue&type=style&index=0&id=e727b21a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e727b21a",
  null
  
)

export default component.exports